import { LanguageCode } from '../../localization/LanguageCode';

class PconLanguageResolver {
  private static readonly defaultLanguage = 'en';

  /**
   * Keys are normalized language codes; values are pCon.ui interface languages.
   * @see https://ui.wiki.pcon-solutions.com/doku.php?id=defaults:languages
   */
  private static readonly languages = new Map([
    ['da-dk', 'da'],
    ['de-at', 'de'],
    ['de-ch', 'de'],
    ['de-de', 'de'],
    ['en-gb', 'en'],
    ['en-us', 'en'],
    ['fr-be', 'fr'],
    ['fr-ch', 'fr'],
    ['fr-fr', 'fr'],
    // pCon.ui has no Norwegian interface
    ['nb-no', 'en'],
    ['nl-be', 'nl'],
    ['nl-nl', 'nl'],
    ['pl-pl', 'pl'],
    ['sv-se', 'sv'],
  ]);

  public static resolve(languageCode: string) {
    return this.languages.get(LanguageCode.normalize(languageCode)) ?? this.defaultLanguage;
  }
}

export default PconLanguageResolver;
